// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';

import menuItems from 'menu-items';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const menu = user.role != 'user' ? menuItems.items : menuItems.items2;
  const navItems = menu.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant='h6' color='error' align='center'>
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
